export default function Shimmer() {
  return (
    <div className="animate-pulse space-y-6">
      <div className="h-8 w-1/2 rounded bg-base-200" />
      <div className="h-6 w-full rounded bg-base-200" />
      <div className="h-6 w-3/4 rounded bg-base-200" />
      <div className="h-48 w-full rounded bg-base-200" />
    </div>
  );
}
